export type DirectEntry = {
  [key: string]: {
    path: string
  }
}

export const directEntries = {
  "patrimonio": {
    path: "/patrimonio",
  },
  "folha": {
    path: "/folha",
  },
  "almoxarifado": {
    path: "/almoxarifado",
  },
  "minhafolha": {
    path: "/minhafolha",
  },
  "frotas": {
    path: "/frotas",
  },
  "compras": {
    path: "/compras",
  },
  "tributos": {
    path: "/tributos",
  },
  "planejamento": {
    path: "/planejamento",
  },
  "tesouraria": {
    path: "/tesouraria",
  },
  "contabil": {
    path: "/contabil",
  },
  "rh": {
    path: "/rh",
  },
  "obras": {
    path: "/obras",
  },
  "contratos": {
    path: "/contratos",
  },
  "e-nota": {
    path: "/e-nota",
  },
  "transparencia": {
    path: "/transparencia",
  },
  "esocial": {
    path: "/esocial",
  },
  "prestacao-contas": {
    path: "/prestacao-contas",
  },
  "studio-aplicacoes": {
    path: "/studio-aplicacoes",
  },
  "documentos": {
    path: "/documentos",
  },
  "beth": {
    path: "/beth",
  },
} as DirectEntry;
